import React, { useRef, useState } from 'react';
import {
  Box,
  Typography,
  Stack,
  Card,
  CardContent,
  Button,
  Divider,
} from '@mui/material';
import { useTreeViewApiRef, RichTreeView } from '@mui/x-tree-view';


export const FilterComponent = ({
  data = [],
  selectedFiltersList = [],
  setSelectedFiltersList = () => {},
  setIsFiltersModalOpen = () => {},
  selectedCompany,
}) => {
  const transformData = (data) => {
    return data.map((item) => {
      const { value, ...rest } = item;
      return {
        ...rest,
        children: transformData(value),
      };
    });
  };
  const defaultExpandedItems = new Set();
  selectedFiltersList.forEach((item) => {
    const tempArr = item.split('|');
    for (let i = 0; i < tempArr.length; i++) {
      const path = tempArr.slice(0, i + 1).join('|');
      defaultExpandedItems.add(path);
    }
  });

  const transformedData = transformData(data);
  const [selectedItems, setSelectedItems] = useState(selectedFiltersList);
  const toggledItemRef = useRef({});
  const apiRef = useTreeViewApiRef();

  const handleItemSelectionToggle = (event, itemId, isSelected) => {
    toggledItemRef.current[itemId] = isSelected;
  };
  function getItemDescendantsIds(item) {
    const ids = [];
    item.children?.forEach((child) => {
      ids.push(child.id);
      ids.push(...getItemDescendantsIds(child));
    });

    return ids;
  }
  const handleSelectedItemsChange = (event, newSelectedItems) => {
    setSelectedItems(newSelectedItems);

    // Select / unselect the children of the toggled item
    const itemsToSelect = [];
    const itemsToUnSelect = {};
    Object.entries(toggledItemRef.current).forEach(([itemId, isSelected]) => {
      const item = apiRef.current.getItem(itemId);
      if (isSelected) {
        itemsToSelect.push(...getItemDescendantsIds(item));
      } else {
        getItemDescendantsIds(item).forEach((descendantId) => {
          itemsToUnSelect[descendantId] = true;
        });
      }
    });

    const newSelectedItemsWithChildren = Array.from(
      new Set(
        [...newSelectedItems, ...itemsToSelect].filter(
          (itemId) => !itemsToUnSelect[itemId],
        ),
      ),
    );

    setSelectedItems(newSelectedItemsWithChildren);

    toggledItemRef.current = {};
  };

  const handleApplyFilters = () => {
    // Apply filters logic here
    setSelectedFiltersList(selectedItems);
    setIsFiltersModalOpen(false);
  };

  const handleClearFilters = () => {
    setSelectedItems([]);
    setSelectedFiltersList([]);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Filters
      </Typography>
      <Divider sx={{ mb: 2 }} />
      
      <Card>
        <CardContent>
          <RichTreeView
            apiRef={apiRef}
            items={transformedData}
            selectedItems={selectedItems}
            onItemSelectionToggle={handleItemSelectionToggle}
            onSelectedItemsChange={handleSelectedItemsChange}
            checkboxSelection
            multiSelect
            defaultExpandedItems={Array.from(defaultExpandedItems)}
          />
        </CardContent>
      </Card>

      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        <Button variant="contained" onClick={handleApplyFilters}>
          Apply Filters
        </Button>
        <Button variant="outlined" onClick={handleClearFilters}>
          Clear Filters
        </Button>
        <Button variant="text" onClick={() => setIsFiltersModalOpen(false)}>
          Cancel
        </Button>
      </Stack>
    </Box>
  );
};
